export interface FeatureFlags {
  recommendations?: string;
  sereca?: string;
  comparisons?: string;
  criteo?: string;
  shopAsst?: string;
  dynamicPdpRecos?: string;
}

export type FeatureFlag = keyof FeatureFlags;

export const isFeatureEnabled = (features: FeatureFlags, currentCountry: string, featureName: FeatureFlag): boolean => {
  const allowedCountriesString = features[featureName];
  if (!allowedCountriesString) return false;
  if (allowedCountriesString === "ALL") return true;

  const allowedCountries = allowedCountriesString.split(",").map((code) => code.trim().toUpperCase());
  const countryCode = currentCountry.toUpperCase();

  return allowedCountries.includes(countryCode);
};

export const createFeatureToggler = (features: FeatureFlags, currentCountry: string) => {
  return (featureName: keyof FeatureFlags): boolean => isFeatureEnabled(features, currentCountry, featureName);
};
